import {InteractionRequiredAuthError} from "@azure/msal-browser";
import {loginRequest} from "../msalConfig";

import {useState} from 'react';
import {useMsal} from "@azure/msal-react";

let cachedToken: string | null = null;
let cachedTokenExpiry: number | undefined = undefined;
let tokenAcquisitionPromise: Promise<string> | null = null;

const useExecWithToken = () => {
    const {instance, accounts, inProgress} = useMsal();

    const fetchToken = async () => {
        if (tokenAcquisitionPromise) {
            return await tokenAcquisitionPromise;
        }

        tokenAcquisitionPromise = (async () => {
            //console.log('Checking for cached token. Expiration: ' + cachedTokenExpiry + ' Now: ' + Date.now());
            if (cachedToken && cachedTokenExpiry && Date.now() < cachedTokenExpiry - 60000) {
                console.log('Using cached token. Will expire in ' + (cachedTokenExpiry - Date.now()) / 1000 + ' seconds')
                return cachedToken;
            }
            console.log('Fetching new token')

            return instance.acquireTokenSilent({...loginRequest, account: accounts[0]})
                .then((result) => {
                    let activeAccount = instance.getAllAccounts()[0];
                    if (activeAccount === undefined || activeAccount === null) {
                        throw new InteractionRequiredAuthError('No account available');
                    }
                    cachedToken = result.idToken;
                    cachedTokenExpiry = result.expiresOn?.getTime();
                    return result.idToken;
                })
                .catch(async (error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        try {
                            const resp = await instance.acquireTokenPopup(loginRequest);
                            cachedToken = resp.idToken;
                            cachedTokenExpiry = resp.expiresOn?.getTime();
                            return resp.idToken;
                        } catch (err) {
                            console.log('Login unsuccessful', error);
                            await instance.logout({postLogoutRedirectUri: '/'})
                            throw new Error('Login unsuccessful');
                        }
                    } else {
                        await instance.logout({postLogoutRedirectUri: '/'})
                        console.log('Unknown error', error);
                        throw new Error('Unknown error');
                    }
                })
                .finally(() => {
                    tokenAcquisitionPromise = null;
                });
        })();

        return await tokenAcquisitionPromise;
    };

    return (callback: (token: string) => void) => {
        fetchToken().then((token) => callback(token))
    };
};

export default useExecWithToken;
